import axios from 'axios';

async function deleteNotificationHome(notificationId) {
  const response = await axios.delete(`/notificationsHome/${notificationId}`);

  return response.data;
}

async function getDashboard( id ) {
  const response = await axios.get('/dashboard/' + id);

  return response.data;
}

async function getNotificationsHome() {
  const response = await axios.get('/notificationsHome');

  return response.data;
}

const dashboardService = {
  deleteNotificationHome,
  getDashboard,
  getNotificationsHome,
}

export default dashboardService;
